// extracted by mini-css-extract-plugin
export default {"img":"ImageElement_img__GwM-l"};